import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const AUGUST_2025_CAMPAIGN_END_DATE = d(2025, 9, 1, 0, 0);
